import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import axios from 'axios';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import TrademarkRegistration from './pages/TrademarkRegistration';
import CopyrightRegistration from './pages/CopyrightRegistration';
import TrademarkSearch from './pages/TrademarkSearch';
import CompanyFormation from './pages/CompanyFormation';
import AmazonBrandRegistry from './pages/AmazonBrandRegistry';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import { Toaster } from './components/ui/sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  // Initialize AOS only on mobile devices
  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    
    if (isMobile) {
      AOS.init({
        duration: 800,
        once: true,
        easing: 'ease-in-out',
        offset: 50,
        delay: 0,
        disable: false,
        startEvent: 'DOMContentLoaded',
        initClassName: 'aos-init',
        animatedClassName: 'aos-animate',
        useClassNames: false,
        disableMutationObserver: false,
        debounceDelay: 50,
        throttleDelay: 99,
      });
      
      // Refresh AOS after initialization to catch elements already in viewport
      setTimeout(() => {
        AOS.refresh();
      }, 100);
    }
  }, []);

  useEffect(() => {
    const helloWorldApi = async () => {
      try {
        const response = await axios.get(`${API}/`);
        console.log(response.data.message);
      } catch (e) {
        console.error(e, `errored out requesting / api`);
      }
    };
    helloWorldApi();
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/trademark-registration" element={<TrademarkRegistration />} />
              <Route path="/copyright-registration" element={<CopyrightRegistration />} />
              <Route path="/trademark-comprehensive-search" element={<TrademarkSearch />} />
              <Route path="/company-formation" element={<CompanyFormation />} />
              <Route path="/amazon-brand-registry" element={<AmazonBrandRegistry />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-center" />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;